"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$toCSV = exports.$streamCSV = exports.$readCSV = void 0;
var __1 = require("../../");
var papaparse_1 = __importDefault(require("papaparse"));
/**
 * Reads a CSV file from local or remote location into a DataFrame.
 * @param filePath URL or local file path to CSV file. `readCSV` uses PapaParse to parse the CSV file,
 * hence all PapaParse options are supported.
 * @param options Configuration object. Supports all Papaparse parse config options.
 * @returns DataFrame containing the parsed CSV file.
 * @throws {Error} If file cannot be read or parsed
 * @example
 * ```
 * import { readCSV } from "danfojs-node"
 * const df = await readCSV("https://raw.githubusercontent.com/test.csv")
 * ```
 * @example
 * ```
 * import { readCSV } from "danfojs-node"
 * const df = await readCSV("https://raw.githubusercontent.com/test.csv", {
 *    delimiter: ",",
 *    headers: {
 *      Accept: "text/csv",
 *      Authorization: "Bearer YWRtaW46YWRtaW4="
 *    }
 * })
 * ```
 * @example
 * ```
 * import { readCSV } from "danfojs-node"
 * const df = await readCSV("./data/sample.csv")
 * ```
 */
var $readCSV = function (file, options) { return __awaiter(void 0, void 0, void 0, function () {
    var frameConfig, hasStringType;
    var _a;
    return __generator(this, function (_b) {
        frameConfig = (options === null || options === void 0 ? void 0 : options.frameConfig) || {};
        hasStringType = (_a = frameConfig.dtypes) === null || _a === void 0 ? void 0 : _a.includes("string");
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var hasError = false;
                papaparse_1.default.parse(file, __assign(__assign({ header: true, dynamicTyping: !hasStringType, skipEmptyLines: 'greedy', delimiter: "," }, options), { error: function (error) {
                        hasError = true;
                        reject(new Error("Failed to parse CSV: " + error.message));
                    }, download: true, complete: function (results) {
                        if (hasError)
                            return; // Skip if error already occurred
                        if (!results.data || results.data.length === 0) {
                            reject(new Error('No data found in CSV file'));
                            return;
                        }
                        if (results.errors && results.errors.length > 0) {
                            reject(new Error("CSV parsing errors: " + results.errors.map(function (e) { return e.message; }).join(', ')));
                            return;
                        }
                        try {
                            var df = new __1.DataFrame(results.data, frameConfig);
                            resolve(df);
                        }
                        catch (error) {
                            var errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                            reject(new Error("Failed to create DataFrame from CSV: " + errorMessage));
                        }
                    } }));
            })];
    });
}); };
exports.$readCSV = $readCSV;
/**
 * Streams a CSV file from local or remote location in chunks. Intermediate chunks is passed as a DataFrame to the callback function.
 * @param filePath URL or local file path to CSV file. `readCSV` uses PapaParse to parse the CSV file,
 * hence all PapaParse options are supported.
 * @param options Configuration object. Supports all Papaparse parse config options.
 * @param callback Callback function to be called once the specifed rows are parsed into DataFrame.
 * @example
 * ```
 * import { streamCSV } from "danfojs-node"
 * streamCSV("https://raw.githubusercontent.com/test.csv", (dfRow) => {
 *     const dfModified = dfRow["Names"].map((name) => name.split(",")[0])
 *     return dfModified
 * })
 * ```
 */
var $streamCSV = function (file, callback, options) { return __awaiter(void 0, void 0, void 0, function () {
    var frameConfig;
    return __generator(this, function (_a) {
        frameConfig = (options === null || options === void 0 ? void 0 : options.frameConfig) || {};
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var _a;
                var count = 0;
                var hasError = false;
                var hasStringType = (_a = frameConfig.dtypes) === null || _a === void 0 ? void 0 : _a.includes("string");
                papaparse_1.default.parse(file, __assign(__assign({ header: true, download: true, dynamicTyping: !hasStringType, delimiter: "," }, options), { step: function (results) {
                        if (hasError)
                            return;
                        try {
                            var df = new __1.DataFrame([results.data], __assign(__assign({}, frameConfig), { index: [count++] }));
                            callback(df);
                        }
                        catch (error) {
                            hasError = true;
                            var errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
                            reject(new Error("Failed to process CSV chunk: " + errorMessage));
                        }
                    }, complete: function () {
                        if (!hasError) {
                            resolve(null);
                        }
                    }, error: function (error) {
                        hasError = true;
                        reject(new Error("Failed to parse CSV: " + error.message));
                    } }));
            })];
    });
}); };
exports.$streamCSV = $streamCSV;
/**
 * Converts a DataFrame or Series to CSV.
 * @param df DataFrame or Series to be converted to CSV.
 * @param options Configuration object. Supports the following options:
 * - `filePath`: Local file path to write the CSV file. If not specified, the CSV will be returned as a string.
 * - `header`: Boolean indicating whether to include a header row in the CSV file.
 * - `sep`: Character to be used as a separator in the CSV file.
 * @example
 * ```
 * import { toCSV } from "danfojs-node"
 * const df = new DataFrame([[1, 2, 3], [4, 5, 6]])
 * const csv = toCSV(df)
 * ```
 * @example
 * ```
 * import { toCSV } from "danfojs-node"
 * const df = new DataFrame([[1, 2, 3], [4, 5, 6]])
 * toCSV(df, {
 *     filePath: "./data/sample.csv",
 *     header: true,
 *     sep: "+"
 *   })
 * ```
 */
var $toCSV = function (df, options) {
    var _a = __assign({ fileName: "output.csv", sep: ",", header: true, download: false }, options), fileName = _a.fileName, download = _a.download, sep = _a.sep, header = _a.header;
    if (df.$isSeries) {
        var csv = df.values.join(sep);
        if (download) {
            if (!(fileName.endsWith(".csv"))) {
                fileName = fileName + ".csv";
            }
            $downloadFileInBrowser(csv, fileName);
        }
        else {
            return csv;
        }
    }
    else {
        var rows = df.values;
        var csvStr = header === true ? df.columns.join(sep) + "\n" : "";
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i].join(sep) + "\n";
            csvStr += row;
        }
        if (download) {
            if (!(fileName.endsWith(".csv"))) {
                fileName = fileName + ".csv";
            }
            $downloadFileInBrowser(csvStr, fileName);
        }
        else {
            return csvStr;
        }
    }
};
exports.$toCSV = $toCSV;
/**
 * Internal function to download a CSV file in the browser.
 * @param content A string of CSV file contents
 * @param fileName  The name of the file to be downloaded
 */
var $downloadFileInBrowser = function (content, fileName) {
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(content);
    hiddenElement.target = '_blank';
    hiddenElement.download = fileName;
    hiddenElement.click();
};
